import { render, staticRenderFns } from "./BasicSelect.vue?vue&type=template&id=4859b7f3&"
import script from "./BasicSelect.vue?vue&type=script&lang=js&"
export * from "./BasicSelect.vue?vue&type=script&lang=js&"
import style0 from "./BasicSelect.vue?vue&type=style&index=0&id=4859b7f3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports